import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import DifferenceIndex from '@/pages/home/components/DifferenceIndex';
import NoteBand from '@/pages/home/components/NoteBand';
import CompareDimensions from '@/pages/home/components/CompareDimensions';
import DigestList from '@/pages/home/components/DigestList';
import GuideSection from '@/pages/home/components/GuideSection';
import FaqSection from '@/pages/home/components/FaqSection';
import SubscribeForm from '@/pages/home/components/SubscribeForm';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="w-full min-h-screen bg-background-50">
      <Navbar />
      <main className="w-full">
        <Hero />
        <DifferenceIndex />
        <NoteBand />
        <CompareDimensions />
        <DigestList />
        <GuideSection />
        <FaqSection />
        <SubscribeForm />
      </main>
      <Footer />
    </div>
  );
}